<template>
    <div class="todo-table table-list">
        <div class="table-list-title">
            <span class="category">分類</span>
            <span class="description">待辦敘述</span>
            <span class="address">地址</span>
        </div>
        <div class="table-list-body">
            <div v-show="loopLimit.length == 0" class="is-empty">0 筆資料</div>
            <ul>
                <li v-for="(item, index) in loopLimit" :key="index" @click="$router.push({name: 'bizBookingMgtDefault'})">
                    <span class="category">{{transTodoListCat(item.category)}}</span>
                    <span class="description">{{item.tenantName}}房客向您預定，您還有<count-down :timeStamp="translateDate(item.expireTime)"></count-down>小時決定簽約</span>
                    <span class="address">{{item.address}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { apiBizGetTodoListBooking } from "@/apis/api.js"; 
import CountDown from '@/components/widge/CountDown.vue';

export default {
    data () {
        return {
            list: ''
        }
    },
    mounted () {
        this.getTodoListBooking()
    },
    props: {
        limit: false 
    },
    watch: {
        filterQuery: {
            handler: function () {
                this.getTodoListBooking()
            },
            deep: true
        }
    },
    methods: {
        getTodoListBooking : function () {
            let data = {
                county: this.filterQuery.county,
                district: this.filterQuery.district,
                groupId: this.filterQuery.groupId,
                memberId: this.filterQuery.memberId
            }


            apiBizGetTodoListBooking(data)
            .then(res => {
                console.log(res)
                if( res.data.status == 'SUCCESS'){
                    this.list = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        translateDate: function (date) {

            let currentDate = new Date(date)
            currentDate = currentDate.setHours(currentDate.getHours())

            return currentDate
        },
    },
    computed: {
        loopLimit: function () {
            if(this.limit){
                return this.list.slice(0, this.limit)
            }else{
                return this.list
            }
        },
        ...mapGetters({
            filterQuery: 'BIZ_TODO_LIST_FILTER_QUERY',
        })
    },
    components: {
        CountDown
    }
}
</script>
<style lang="scss" scoped>
    .todo-table{
        &.table-list{
            width: 100%;
            border-radius: 0;
            border-left: none;
            border-right: none;
            border-bottom: none;
            box-sizing: border-box;
            .table-list-body ul li{
                align-items: flex-start;
                cursor: pointer;
            }
        }
        .category{
            width: 76px;
            margin-right: 60px;
        }
        .description{
            display: flex !important;
            align-items: center;
            flex-wrap: wrap;
            width: 200px;
            margin-right: 60px;
            line-height: 1.5;
            .countdown{
                color: #292625;
            }
        }
        .address{
            width: 240px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalHome/home/todoList/todoBooking.vue